"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsubscribeMemberResponseSchema = void 0;
var zod_1 = require("zod");
exports.UnsubscribeMemberResponseSchema = zod_1.z.string();
